<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaConfigurazione">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <sa-filter-component @submit="onSubmit" @reset="onReset">
                <b-row>
                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-search-box-label">Codice</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroAccessiCategorie.codice" placeholder="Ricerca per codice" />
                        </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-search-box-label">Descrizione</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroAccessiCategorie.descrizione" placeholder="Ricerca per descrizione" />
                        </div>
                    </b-col>
                </b-row>
            </sa-filter-component>
        </template>
        <template slot="table-body">
            <rsa-configurazione-pai-domiciliare-accessi-categorie-list-component-vue ref="cmpRsaConfigurazionePaiDomiciliareAccessiCategorieList"></rsa-configurazione-pai-domiciliare-accessi-categorie-list-component-vue>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazionePaiDomiciliareAccessiCategorieListComponentVue from "../components/RsaConfigurazionePaiDomiciliareAccessiCategorieListComponent.vue";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";

export default {
    components: { SaPageLayout, RsaConfigurazionePaiDomiciliareAccessiCategorieListComponentVue, SaFilterComponent },
    data() {
        return {
            pathResource: "",
            btnConfigurazioniVisible: true,
            showModalLoading: false,
            linkConfigurazioni: "/configurazioni",
            filtroAccessiCategorie: { descrizione: null, codice: null },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroAccessiCategorie"]) {
            me.filtroAccessiCategorie = JSON.parse(sessionStorage["filtroAccessiCategorie"]);
        }
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePaiDomiciliareAccessiCategorieList.loadData();
        },
        onClickNuovaConfigurazione() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePaiDomiciliareAccessiCategorieList.onClickNuovCategoria();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onRefresh() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePaiDomiciliareAccessiCategorieList.loadData();
        },
        onReset() {
            let me = this;
            me.filtroAccessiCategorie = { descrizione: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroAccessiCategorie"] = JSON.stringify(me.filtroAccessiCategorie);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroAccessiCategorie"] = JSON.stringify(me.filtroAccessiCategorie);
            me.loadData();
        },
    },
};
</script>
